import { Product } from "~/bff/types/Product";
import { ClickCollectStatuses } from "~/constants/data-layer";

export const clickAndCollectSkuStatusGA = (
  product: Product | undefined,
  isSizeSelected: boolean,
  sku: string | undefined,
): string | boolean | undefined | null => {
  if (!isSizeSelected) {
    return ClickCollectStatuses.skuNotYetSelected;
  } else {
    const selectedSku = product?.variants?.find((product) => product?.sku === sku);
    const eligibility = selectedSku
      ? selectedSku?.clickAndCollect || selectedSku?.clickAndCollectExclusive
      : product?.clickAndCollect || product?.clickAndCollectExclusive;

    return eligibility;
  }
};
